import { jt_info } from '@/interfaces/jt_info'
import { jtStatusRequest, jtStatusEnum, jtStatusICWEnum } from '../network/requests/jtStatus'
import { jtInfoRequest } from '../network/requests/jtInfo'
import { defectStatisRequest } from '@/network/requests/defectStatis'
import { jobOrderRequest } from '@/network/requests/jobOrder'
import { defect_statis } from '@/interfaces/defect_statis'
import { job_order } from '@/interfaces/job_order'
import { realBatchInfoRequest } from '@/network/requests/realBatchInfo'
import { jt_status } from '@/interfaces/jt_status'
import moment from 'moment'
import { formatDate } from '@/util/datetime'
import { workshop } from '@/interfaces/workshop'
import { workshopRequest } from '@/network/requests/workshop'
import { queryTechGroupDetailById } from '@/network/requests/techGroup'
import { jtTechRequest } from '@/network/requests/jtTech'
import { product } from '@/interfaces/product'
import { productRequest } from '@/network/requests/product'
import { jt_tech } from '@/interfaces/jt_tech'
import { process_Info } from '@/interfaces/process_Info'
import { getProcessGroupDetails } from '@/network/requests/processGroupDetail'
import { processInfoRequest } from '@/network/requests/processInfo'

// 缓存机台状态信息：jtId -> { status, count, timestamp }
const deviceStatusHistoryCache = localStorage.getItem('jt_status')
let deviceStatusHistory = {}
if (deviceStatusHistoryCache) {
	try {
		deviceStatusHistory = JSON.parse(deviceStatusHistoryCache)
	} catch (e) {
		deviceStatusHistory = {}
	}
}

/**
 * 从本地缓存读取机台状态信息：
 * @param status_info
 */
var getDeviceStatusFromCache = (status_info: jt_status) => {
	if (!status_info) return {}
	const jt_id = status_info.jt_id!
	const count = status_info.count
	const status = status_info.status
	const timestamp = new Date().getTime()

	const prevStatus = deviceStatusHistory[jt_id]
	if (prevStatus && count === prevStatus.count) {
		// count 一致，进一步判断时间
		const timePast = timestamp - prevStatus.timestamp
		if (timePast >= 1000 * 10) {
			// 如果已经大于10秒
			status_info.status = 0
			status_info.status_icw = 0
			//console.log('从本地缓存读取机台状态信息，如果已经大于10秒', status_info)
		}
	} else {
		deviceStatusHistory[jt_id] = {
			count,
			status,
			timestamp,
		}

		//console.log('本地缓存没有记录，添加机台状态。', count, status, timestamp)
	}

	localStorage.setItem('jt_status', JSON.stringify(deviceStatusHistory))

	return status_info
}

/**
 * 获取机台运行状态；
 */
var getJTStatusText = (statusInfo: jt_status) => {
	if (!statusInfo) return '未知'

	if (statusInfo.status == undefined) {
		statusInfo.status = 0
	}

	const newStatus: jt_status = getDeviceStatusFromCache(statusInfo)

	if (jtStatusEnum[newStatus.status!]) {
		return jtStatusEnum[newStatus.status!].text
	}
}

/**
 * 获取机台运行状态；
 */
var getJTStatusTextByValue = value => {
	if (!value) value = 0

	if (jtStatusEnum[value]) {
		return jtStatusEnum[value].text
	}
}

/**
 * 获取机台检测状态。
 * @param statusInfo
 */
var getJTCheckStatusText = statusInfo => {
	if (!statusInfo) return '--'
	if (jtStatusICWEnum[statusInfo.status_icw]) {
		return jtStatusICWEnum[statusInfo.status_icw].text
	} else {
		return statusInfo.status_icw
	}
}

/**
 * 获取机台状态信息，此处只适用于单个机台查询，请尽量避免循环调用此方法。
 * @param jt
 */
var getJTStatusByJT = async (jt: jt_info) => {
	console.log('机台信息', jt)

	//机台Id。
	var jt_id = jt._id?.$oid
	//车间。
	var ws: workshop | undefined = {}
	if (jt.workshop_id) {
		ws = await (await workshopRequest.getDocumentById(jt.workshop_id!)).data
	}

	//查询机台状态。
	var jtStatus: jt_status | null = null
	try {
		jtStatus = (await jtStatusRequest.queryAll({ jt_id: jt_id }))[0]
	} catch (error) {
		jtStatus = {}
	}

	//机台状态的批次Id。
	var jt_status_roll_id = ''
	if (jtStatus) {
		if (jt_status_roll_id.length == 0) {
			jt_status_roll_id = jtStatus.roll_id!
		}
	}

	//获取到卷的基本信息【根据机台状态中的批次查询批次信息】。
	var roll_info: defect_statis | null = null
	if (jt_status_roll_id) {
		try {
			roll_info = await (await defectStatisRequest.getDocumentById(jt_status_roll_id)).data
			console.log('机台 roll_info', roll_info)
		} catch (error) {
			console.error('机台roll_id获取defectStatis失败', jt_status_roll_id)
		}
	} else {
		console.warn('机台roll_id获取defectStatis失败', jt_status_roll_id)
	}

	//根据批次信息查询工单。
	var job_order_id = ''
	var jobOrderInfo: job_order | null = null
	var product: product | null = null

	if (roll_info) {
		if (roll_info.job_order_id) {
			job_order_id = roll_info.job_order_id!
		}

		//从此表的job_order_id查询job_order h获取到code 就是工单号
		if (job_order_id) {
			try {
				jobOrderInfo = await (await jobOrderRequest.getDocumentById(job_order_id)).data
			} catch (error) {
				jobOrderInfo = null
			}
		}

		if (roll_info.product_id) {
			product = (await productRequest.getDocumentById(roll_info.product_id)).data
		}
	}

	//当前工序。
	var process_list: process_Info[] = []
	//下一工序。
	var next_process: string | undefined = ''
	//剩余长度 = 总长度 - 完成的长度
	var remainLen = 0
	//完成的长度
	var completeLen = 0
	//批次缺陷米数总和
	var badLen = 0
	//缺陷张数。
	var badCount = 0
	//批次张数。
	var defectCount = 0
	//总长度。
	var totalLen = 0
	//获取开始时间。
	var beginTime = new Date().getTime()
	//使用job_order 对关联的批次进行统计。
	if (jobOrderInfo) {
		//总长度。
		totalLen = jobOrderInfo?.total_len ?? 0
		var defectStatis = await defectStatisRequest.queryAll({ job_order_id: job_order_id })

		if (defectStatis.length > 0) {
			var defectStatis_ids = defectStatis.map(p => p._id?.$oid)

			var all_realBatchs = await realBatchInfoRequest.queryAll({ roll_id: { $in: defectStatis_ids } }, undefined, undefined, 1000)

			for (var item of defectStatis) {
				//通过defect_static中的ID查询real_batch_info的roll_id获取
				var realBatchs = all_realBatchs.filter(t => t.roll_id == item._id?.$oid)

				if (realBatchs.length > 0) {
					for (var v of realBatchs) {
						//completeLen += v.totle_len ?? 0
						//badLen += v.bad_len ?? 0
					}
				}

				if (item.total_len) {
					completeLen += item.total_len! / 1000
				}

				//totalLen += item.total_len ?? 0
				badCount += item.bad_count ?? 0
				defectCount += item.Insp_count ?? 0 + realBatchs.length
			}

			console.log('real_batch_info_count', jobOrderInfo._id?.$oid, all_realBatchs?.length)
		}

		//剩余长度 = 总长度 - 完成的长度
		remainLen = totalLen - completeLen
		beginTime = jobOrderInfo?.begin_time!.$date ?? 0

		if (jobOrderInfo.process_group_id) {
			var process_details = await getProcessGroupDetails(jobOrderInfo.process_group_id)
			for (var pd of process_details) {
				var process_info = (await processInfoRequest.getDocumentById(pd.process_id!)).data
				process_list.push(process_info)
			}
		}

		if (process_list.length > 0) {
			next_process = process_list[0].name
		}

		var process_str = process_list.map(p => p.name).join(',')
	}

	//当前时间。
	var timestamp = new Date().getTime()
	//已消耗时间(分钟)
	var elapsedTime = moment(timestamp).diff(moment(beginTime), 'minutes')
	//剩余时间 = 剩余长度 / (已完成长度 / 已消耗时间)
	var remaining = remainLen / (completeLen / elapsedTime)
	//进度 = 完成长度 / 总长度
	var progress = completeLen / totalLen
	//良率= 1 - 缺陷张数 / 批次张数
	var yieldRate = Math.abs(1 - badCount / defectCount!)

	console.log('remainLen', remainLen)
	console.log('completeLen', completeLen)
	console.log('elapsedTime', elapsedTime)
	console.log('badCount', badCount)
	console.log('defectCount', defectCount)
	console.log('totalLen', totalLen)

	if (isNaN(yieldRate)) yieldRate = 0
	if (isNaN(progress)) progress = 0
	if (isNaN(remaining) || !isFinite(remaining)) remaining = 0

	//机台工艺集合。
	var jtTechs: jt_tech[] = []
	try {
		jtTechs = await jtTechRequest.queryAll({ jt_id: jt_id })
	} catch (error) {
		console.error('无法获取机台工艺信息，请求出错。')
	}

	var result = {
		...jt,
		workshop: ws,
		statusInfo: jtStatus,
		startTime: formatDate(jobOrderInfo?.begin_time!),
		remaining: remaining.toFixed(2),
		progress: parseFloat((progress * 100).toFixed(2)),
		work_order_code: jobOrderInfo?.code,
		yield_rate: (yieldRate * 100).toFixed(1) + '%',
		statusText: getJTStatusText(jtStatus),
		checkStatus: getJTCheckStatusText(jtStatus),
		techs: jtTechs,
		product: product,
		productName: product?.name,
		next_process: next_process,
	}

	return result
}

/**
 * 获取机台状态信息。
 * @param jtId
 */
var getJTStatus = async (jt_id: string) => {
	//查询机台信息。
	var jt: jt_info = await (await jtInfoRequest.getDocumentById(jt_id)).data

	return getJTStatusByJT(jt)
}

/**
 * 获取机台状态信息。
 * @param jt_id
 */
var getJTStatusInfo = async (jt_id: string) => {
	//查询机台状态。
	var jtStatus: jt_status | null = null
	try {
		jtStatus = (await jtStatusRequest.queryAll({ jt_id: jt_id }))[0]
	} catch (error) {
		jtStatus = {}
	}

	return jtStatus
}

/**
 * 获取机台工艺参数信息。
 * @param jt_id
 * @param tech_group_id
 */
var getJTTechParams = async (jt_id: string, tech_group_id: string) => {
	var techInfo: any[] = []
	var techGroupDetails = await queryTechGroupDetailById(tech_group_id)
	var techParams = await jtTechRequest.queryAll({ jt_id: jt_id })

	console.log('techGroupDetails', techGroupDetails)
	console.log('techParams', techParams)

	techGroupDetails.forEach((v, i) => {
		var jt_techItem = techParams.find(t => t.tech_id == v._id?.$oid)
		var techValue: number | undefined
		if (jt_techItem) {
			techValue = jt_techItem.value
		}

		techInfo.push({
			...v,
			value: techValue ?? '--',
		})
	})

	return techInfo
}

/**
 * 获取设备状态信息列表，这里使用mongodb聚合查询。
 * @param pageIndex 当前页码。
 * @param pageSize 每页记录数量。
 * @param filter 查询条件，不能随意拼接；请参考：聚合查询中的条件。
 */
var getDeviceStatusList = async (pageIndex = 1, pageSize = 10, filter: any | undefined) => {
	var params = {
		page: pageIndex,
		pagesize: pageSize,
	}

	var list: any[] = []
	var response: any = {}
	if (filter) {
		params['avars'] = {
			jt_id: filter.jt_id,
			workshop_id: filter.workshop_id ?? '',
		}

		response = await (await jtInfoRequest.aggregateQuery('device-status-stat-by-params', params)).data
	} else {
		response = await (await jtInfoRequest.aggregateQuery('device-status-stat', params)).data
	}

	var _embedded = response._embedded

	_embedded.forEach(element => {
		//当前时间。
		var timestamp = new Date().getTime()
		const jtId = element.jtId
		const count = element.status_info.count
		const status = element.status_info.status
		const prevStatus = deviceStatusHistory[jtId]

		if (prevStatus && count === prevStatus.count) {
			// count 一致，进一步判断时间
			const timePast = timestamp - prevStatus.timestamp
			if (timePast >= 1000 * 10) {
				// 如果已经大于10秒
				element.status_info.status = 0
				element.status_info.status_icw = 0
			}
		} else {
			deviceStatusHistory[jtId] = {
				count,
				status,
				timestamp,
			}
		}

		var jobOrder = element.job_order ?? {}

		//完成的长度
		var completeLen = jobOrder.completeLen / 1000
		//缺陷张数。
		var badCount = jobOrder.badCount
		//批次张数。
		var defectCount = jobOrder.inspCount + jobOrder.real_batch_info_count
		//总长度。
		var totalLen = jobOrder.total_len
		//获取开始时间。
		var beginTime = jobOrder?.begin_time?.$date ?? new Date().getTime()

		//剩余长度 = 总长度 - 完成的长度
		var remainLen = totalLen - completeLen

		//已消耗时间(分钟)
		var elapsedTime = moment(timestamp).diff(moment(beginTime), 'minutes')
		//剩余时间 = 剩余长度 / (已完成长度 / 已消耗时间)
		var remaining = remainLen / (completeLen / elapsedTime)
		//进度 = 完成长度 / 总长度
		var progress = completeLen / totalLen
		//良率= 1 - 缺陷张数 / 批次张数
		var yieldRate = Math.abs(1 - badCount / defectCount!)

		// console.log('remainLen', remainLen)
		// console.log('completeLen', completeLen)
		// console.log('elapsedTime', elapsedTime)
		// console.log('badCount', badCount)
		// console.log('defectCount', defectCount)
		// console.log('totalLen', totalLen)

		if (isNaN(yieldRate)) yieldRate = 0
		if (isNaN(progress)) progress = 0
		if (isNaN(remaining) || !isFinite(remaining)) remaining = 0

		list.push({
			id: element._id.$oid,
			workshop: element.workshop,
			name: element.name,
			productName: jobOrder.product?.name,
			remaining: parseFloat(remaining.toFixed(2)),
			code: jobOrder.code,
			yield_rate: parseFloat((yieldRate * 100).toFixed(2)),
			tech_group_id: element.tech_group_id,
			status: element.status_info.status,
			status_icw: element.status_info.status_icw,
			status_text: getJTStatusTextByValue(element.status_info.status),
			status_icw_text: getJTCheckStatusText(element.status_info),
			startTime: formatDate(jobOrder?.begin_time!),
			progress: parseFloat((progress * 100).toFixed(2)),
		})
	})
	localStorage.setItem('jt_status', JSON.stringify(deviceStatusHistory))
	return {
		data: list,
		pageCount: response._total_pages,
		dataCount: response._size,
	}
}

export default {
	getJTStatus,
	getJTTechParams,
	getJTStatusInfo,
	getJTStatusText,
	getDeviceStatusList,
	getJTStatusTextByValue,
	getDeviceStatusFromCache,
}
